import { Injectable, EventEmitter } from '@angular/core';
import { Principal } from '../auth/principal.service';
import { CoreConfigService } from '../config/core-config.service';
import { UserStorageService } from './user-storage.service';

@Injectable({ providedIn:'root' })
export class UserContextService {
    private data: {[key: string]: any} = {};
    dataChange: EventEmitter<{ key:string, value: any}> = new EventEmitter();

    currentAppChange: EventEmitter<any> = new EventEmitter();
    currentOfficeChange: EventEmitter<any> = new EventEmitter();

    constructor(
        private principal: Principal,
        private userStorage: UserStorageService,
		private configService: CoreConfigService,
    ) {
        this.principal.authenticationStateChange.subscribe(account=>{
            this.clearData();
        });
        this.userStorage.dataChange.subscribe(data=>{
            if(data.key == 'currentApp') this.currentAppChange.emit(data.value);
            else if(data.key == 'currentOffice') this.currentOfficeChange.emit(data.value);
            this.dataChange.emit(data);
        });
    }
    private clearData(){
        this.data={};
    }

    putData(key: string, value: any): boolean {
        if(this.data[key] !== value){
            this.data[key] = value;
            this.dataChange.emit({key:key, value:value});
            return true;
        }
        return false;
    }
    getData(key: string) : any {
        return this.data[key];
    }

    get identity(): Promise<any>{
        console.warn("停用identity()方法，改为getCurrentUser()");
        return this.getCurrentUser();
    }
    get userAccount() {
        console.warn("停用userAccount()方法，改为currentUser()");
        return this.currentUser;
    }
    getCurrentUser() : Promise<any> {
        return this.principal.identity();
    }
    get currentUser() {
        return this.principal.userIdentity;
    }
    get currentUserId() : number {
        return this.principal.authenticatedUserId;
    }
    get isAuthenticated() : boolean {
        return this.principal.isAuthenticated();
    }
    
    get currentApp() : any {
        return this.userStorage.getCurrentApp();
    }
    get currentAppId() : any {
        const app = this.currentApp;
        return app?app.id:null;
    }
    get currentOffice() : any {
        return this.userStorage.getCurrentOffice();
    }
    get currentOfficeId() : number {
        const office = this.currentOffice;
        return office?office.id:null;
    }

    addPage404(routerLink: string){
        return !!this.putData("AppHome404_"+ routerLink, true);
    }
    isPage404(routerLink: string):boolean{
        if(routerLink == null||routerLink == "") return true;
        return !!this.getData("AppHome404_"+ routerLink);
    }
}